import React from 'react';

function ScheduleCalendar({ platforms, onChange }) {
  return (
    <div>
      {/* Placeholder for ScheduleCalendar component */}
      {platforms.map(platform => (
        <div key={platform}>
          <p>{platform} Schedule</p>
          <input type="datetime-local" onChange={(e) => onChange({ platform, schedule: e.target.value })} />
        </div>
      ))}
    </div>
  );
}

export default ScheduleCalendar; 